import React from 'react';
import { motion } from 'framer-motion';

/**
 * A selectable card with hover/tap feedback — replaces plain <select>/toggle-button choices
 * (garment source, placements, delivery method, etc.) across the order flow.
 */
export default function OptionCard({ title, description, selected, onClick, style }) {
  return (
    <motion.button
      type="button"
      onClick={onClick}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.97 }}
      className={`option-card${selected ? ' is-selected' : ''}`}
      style={style}
    >
      <div className="option-card-title">
        <span>{title}</span>
        {selected && <span className="option-card-check">✓</span>}
      </div>
      {description && <div className="option-card-desc">{description}</div>}
    </motion.button>
  );
}
